import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'app-tryout-messages-not-in-use',
  templateUrl: './tryout-messages-not-in-use.component.html',
  styleUrls: ['./tryout-messages-not-in-use.component.css']
})
export class TryoutMessagesNotInUseComponent implements OnInit {

  @Input() NoOfMessagesNotInUse: string;
  @Output() filterProgramsEvent = new EventEmitter();

  program_status = '';

  constructor() { }

  ngOnInit() {
  }

  filterProgramListing(value) {
    this.program_status = value;
    this.filterProgramsEvent.emit(this.program_status);
  }
}



// WEBPACK FOOTER //
// ./src/app/tryout/components/tryout-messages-not-in-use/tryout-messages-not-in-use.component.ts